{
    function webpBad() {
        console.log("webp is BAD.");
        document.documentElement.classList.add('no-webp');
    }
    let webpSrc = 'data:image/jpeg;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
    let image = new Image();
    image.onerror = webpBad;
    // image.onload = webpOk;
    image.src = webpSrc;
    // console.log("webpTest was ran.");

}